import { Enums } from '../../../models/common/enums'
import { IOpObject } from '../../../models/util/interfaces'
import { OpDevice } from '../../../models/core/op-device'

import { CommonHelper } from '../../../helpers/common-helper'
import { EventsNames } from '../../../helpers/events-names'
import { IUserSession } from '../../../helpers/user-session'
import { LocalizationHelper } from '../../../helpers/localization-helper'
import { LogHelper } from '../../../helpers/log-helper'

import { DeviceService } from '../../../services/device'
import { LoggerService } from '../../common/common.module'

import { BulkEditInitParams, CreateEditInitParams } from '../../common/create-edit-popup/create-edit-popup.controller'
import { CreateEditController, CreateEditScope } from '../../common/common.create-edit.controller'
import { PopupType } from './../../../helpers/popup-manager'

interface DeviceCreateEditScope extends CreateEditScope { }

export class DeviceCreateEditController
    extends CreateEditController
{
    // Members

    private referenceValue: OpDevice;

    // Members End

    constructor(
        private $scope: DeviceCreateEditScope,
        private $q: ng.IQService,
        private $timeout: ng.ITimeoutService,
        private logger: LoggerService,
        protected userSession: IUserSession,
        public referenctType: Enums.ReferenceType,
        private moduleName: Enums.SimaxModuleName,
        private deviceService: DeviceService
    ) {
        super(referenctType)

        this.setEvents()
        this.setOptions()
    }

    // Events

    public onInit(args: any[]): void {
        if (args && args[0]) {
            const createEditInitParams: CreateEditInitParams = args[0]

            this.referenceValue = createEditInitParams ? <OpDevice>createEditInitParams.referenceObject : null
            this.$scope.$broadcast(EventsNames.SHOW_CREATE_EDIT_POPUP, PopupType.CREATE_EDIT_POPUP)

            if (this.referenceValue && this.referenceValue.idObject > 0) {
                this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__EDITING, this.moduleName)
            } else {
                this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__ADDING, this.moduleName)
            }

            this.$timeout(() => {
                this.$scope.$broadcast(EventsNames.OPEN_CREATE_EDIT_POPUP, createEditInitParams)
            }, 100)
        }
    }

    public onInitBulk(args: any[]): void {
        if (args && args[0]) {
            const bulkEditInitParams: BulkEditInitParams = args[0]

            this.$scope.$broadcast(EventsNames.SHOW_CREATE_EDIT_POPUP, PopupType.BULK_EDIT_POPUP)

            this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__MASS_EDITING, this.moduleName)

            this.$scope.gridData = args[0]
            this.$scope.gridColumns = args[1]

            this.$scope.$broadcast(EventsNames.OPEN_BULK_EDIT_POPUP, bulkEditInitParams)
        }
    }

    public onSave(objectToSave: IOpObject): ng.IPromise<IOpObject> {
        const deferred = this.$q.defer<IOpObject>()

        this.deviceService
            .saveDevice(this.userSession.getDataProvider(), OpDevice.fromIOpObject(objectToSave), this.moduleName)
            .then((savedObject: OpDevice) => {
                this.$scope.$root.$broadcast(EventsNames.CLOSE_CREATE_EDIT_POPUP, savedObject)

                deferred.resolve(savedObject)
            })
            .fail((error: any) => {
                LogHelper.error(DeviceService.LOG_PREFIX, error)
                deferred.reject(error)
            })

        return deferred.promise
    }

    public onBulkSave(objectToSave: IOpObject): ng.IPromise<IOpObject> {
        const deferred = this.$q.defer<IOpObject>()

        this.deviceService
            .saveDevice(this.userSession.getDataProvider(), OpDevice.fromIOpObject(objectToSave), this.moduleName, true)
            .then((savedObject: OpDevice) => {
                deferred.resolve(savedObject)
            })
            .fail((error: any) => {
                LogHelper.error(DeviceService.LOG_PREFIX, error)
                deferred.reject(error)
            })

        return deferred.promise
    }

    // Events End

    // Setup

    public setEvents(): void {
        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_CREATE_EDIT_POPUP, this.moduleName),
            (event: ng.IAngularEvent, ...args: any[]) => this.onInit(args)
        )

        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_BULK_EDIT_POPUP, this.moduleName),
            (event: ng.IAngularEvent, ...args: any[]) => this.onInitBulk(args)
        )
    }

    public setOptions(): void {
        this.$scope.popupVisible = false
        this.$scope.options = {
            localStorageVarForSavedEntity: CommonHelper.localStorageVarForSavedEntity.deviceSaved,
            onSubmit: null,
            onClose: null,
            referenceType: this.referenceType,
            submitBulkEdit: null,
            succsessMessage: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__SAVED, this.moduleName),
            title: '',
            type: null,

            onBulkSave: (objectToSave: IOpObject) => this.onBulkSave(objectToSave),
            onSave: (objectToSave: IOpObject) => this.onSave(objectToSave),
        }
    }
    
    // Setup End
}